import { render, staticRenderFns } from "./SettingsExtOfficeModal.vue?vue&type=template&id=5cfd4b28&"
import script from "./SettingsExtOfficeModal.vue?vue&type=script&lang=js&"
export * from "./SettingsExtOfficeModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingsExtOfficeModal.vue?vue&type=style&index=0&id=5cfd4b28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports